module.exports = __webpack_public_path__ + "static/Button_Playstore-6dbc0a62d5fbdf2741087dbaea820558.png";